import { Component} from '@angular/core';
 
@Component({
    selector: 'app-alteracaodebeneficio',
    templateUrl: './alteracaodebeneficio.component.html',
    styleUrls: ['./alteracaodebeneficio.component.scss']
})


export class alteracaodebeneficioComponent {}